export const operaciones = [
  {
    name: 'disponibilidades_01',
    data: [
      'A1001',
      'A1002',
      'A1003',
      'A1004',
      'A1005',
      'A1006',
      'A1007',
      'A1008',
      'A1009',
      'A1010',
      'A1011',
      'A1012',
      'A1013',
      'A1014',
      'A1015',
      'A1016',
      'A1017',
      'A1018',
      'A1019',
    ],
    bandas: [
      0
    ]
  },{
    name: 'carteracreditos_01',
    data: [
      'A1021',
      'A1022',
      'A1023',
      'A1024',
      'A1025',
      'A1026',
      'A1027',
      'A1028',
      'A1029',
      'A1030',
      'A1031',
      'A1032',
      'A1033',
      'A1034',
      'A1035',
      'A1036',
      'A1037',
      'A1038',
      'A1039',
      'A1040',
    ],
    bandas: [
      0
    ]
  },{
    name: 'inversiones_01',
    data: [
      'A1043',
      'A1044',
      'A1045',
    ],
    bandas: [
      0
    ]
  },{
    name: 'inversiones_02',
    data: [
      'A1047',
      'A1048',
      'A1049',
    ],
    bandas: [
      0
    ]
  },{
    name: 'inversiones_03',
    data: [
      'A1051',
      'A1052',
      'A1053',
    ],
    bandas: [
      0
    ]
  },{
    name: 'valores_01',
    data: [
      'A1055',
      'A1056',
      'A1058',
    ],
    bandas: [
      0
    ]
  },{
    name: 'valores_02',
    data: [
      'A1046',
      'A1050',
      'A1054',
      'A1057',
      'A1059',
    ],
    bandas: [
      11
    ]
  },{
    name: 'cuentascobrar_01',
    data: [
      'A1062',
      'A1063',
      'A1064',
      'A1065',
      'A1066',
      'A1067',
      'A1068',
      'A1069',
      'A1070',
      'A1071',
      'A1072',
      'A1073',
      'A1074',
      'A1075',
      'A1076',
      'A1077',
      'A1078',
      'A1079',
      'A1080',
      'A1081',
      'A1082',
      'A1083',
      'A1084',
      'A1085',
    ],
    bandas: [
      11
    ]
  },{
    name: 'activosfijos_01',
    data: [
      'A1086',
      'A1087',
      'A1088',
      'A1089',
      'A1090',
      'A1091',
      'A1092',
      'A1093',
      'A1094',
      'A1095',
      'A1096',
      'A1097',
      'A1098',
      'A1099',
      'A1100',
      'A1101',
      'A1102',
      'A1103',
      'A1104',
      'A1105',
      'A1106',
      'A1107',
      'A1108',
      'A1109',
    ],
    bandas: [
      11
    ]
  },{
    name: 'participaciones_01',
    data: [
      'A1110',
      'A1111',
      'A1112',
    ],
    bandas: [
      11
    ]
  },{
    name: 'otrosactivos_01',
    data: [
      'A1116',
      'A1117',
      'A1118',
      'A1119',
      'A1120',
      'A1121',
      'A1122',
      'A1123',
      'A1124',
      'A1125',
      'A1126',
      'A1127',
      'A1128',
      'A1129',
      'A1130',
      'A1131',
      'A1132',
      'A1133',
      'A1134',
      'A1135',
      'A1136',
      'A1137',
      'A1138',
      'A1139',
    ],
    bandas: [
      11
    ]
  },{
    name: 'contingencias_01',
    data: [
      'O6001',
      'O6002',
      'O6003',
      'O6004',
      'O6005',
      'O6006',
      'O6007',
      'O6008',
      'O6009',
      'O6010',
      'O6011',
      'O6012',
      'O6013',
      'O6014',
      'O6015',
      'O6016',
      'O6017',
      'O6018',
      'O6019',
      'O6020',
      'O6021',
      'O6022',
    ],
    bandas: [
      11
    ]
  },{
    name: 'provisiones_01',
    data: [
      'A1020',
      'A1041',
      'A1042',
      'A1060',
      'A1061',
      'A1113',
      'A1114',
      'A1115',
      'A1140',
      'A1141',
      'A1142',
      'A1143',
      'A1144',
    ],
    bandas: [
      11
    ]
  },{
    name: 'otrosactivos_02',
    data: [
      'A1145',
      'A1146',
      'A1147',
      'A1148',
      'A1149',
      'A1150',
      'A1151',
      'A1152',
      'A1153',
      'A1154',
      'A1155',
      'A1156',
      'A1157',
      'A1158',
      'A1159',
    ],
    bandas: [
      11
    ]
  },{
    name: 'fondos_01',
    data: [
      'P2012',
      'P2018',
    ],
    bandas: [
      0,
      1,
      2,
      3
    ]
  },{
    name: 'depositos_01',
    data: [
      'P2001',
      'P2002',
      'P2003',
      'P2004',
      'P2005',
      'P2006',
      'P2007',
      'P2013',
    ],
    bandas: [
      11
    ]
  },{
    name: 'depositos_02',
    data: [
      'P2008',
      'P2009',
      'P2010',
      'P2011',
      'P2014',
      'P2017',
      'P2037',
      'P2038',
      'P2039',
      'P2040',
      'P2044',
    ],
    bandas: [
      11
    ]
  },{
    name: 'depositos_03',
    data: [
      'P2015',
      'P2016',
      'P2019',
      'P2020',
      'P2021',
      'P2022',
      'P2023',
      'P2024',
      'P2025',
      'P2026',
      'P2027',
      'P2028',
      'P2029',
      'P2030',
      'P2031',
      'P2032',
      'P2033',
      'P2034',
      'P2035',
      'P2036',
      'P2041',
      'P2042',
      'P2043',
    ],
    bandas: [
      11
    ]
  },{
    name: 'financiamientos_01',
    data: [
      'P2045',
      'P2046',
      'P2047',
      'P2048',
      'P2049',
      'P2050',
      'P2051',
      'P2052',
      'P2053',
      'P2054',
      'P2055',
      'P2056',
      'P2057',
      'P2058',
      'P2059',
      'P2060',
      'P2061',
      'P2062',
      'P2063',
      'P2064',
      'P2065',
      'P2066',
      'P2067',
      'P2068',
      'P2069',
      'P2070',
    ],
    bandas: [
      11
    ]
  },{
    name: 'obligaciones_01',
    data: [
      'P2071',
      'P2072',
      'P2073',
      'P2074',
      'P2075',
      'P2076',
      'P2077',
      'P2078',
      'P2079',
      'P2080',
      'P2081',
      'P2082',
      'P2083',
      'P2084',
      'P2085',
      'P2086',
      'P2087',
      'P2088',
      'P2089',
      'P2090',
      'P2091',
      'P2092',
      'P2093',
      'P2094',
    ],
    bandas: [
      11
    ]
  },{
    name: 'acreedores_01',
    data: [
      'P2099',
      'P2100',
      'P2101',
      'P2102',
      'P2103',
      'P2104',
      'P2105',
      'P2106',
      'P2107',
      'P2108',
      'P2109',
      'P2110',
      'P2111',
      'P2112',
      'P2113',
      'P2114',
      'P2115',
      'P2116',
      'P2117',
      'P2118',
      'P2121',
      'P2122',
      'P2123',
      'P2124',
      'P2125',
    ],
    bandas: [
      11
    ]
  },{
    name: 'pasivos_01',
    data: [
      'P2126',
      'P2127',
      'P2128',
      'P2129',
      'P2130',
      'P2131',
      'P2132',
      'P2133',
      'P2134',
      'P2135',
    ],
    bandas: [
      11
    ]
  },{
    name: 'fondos_02',
    data: [
      'P2095',
      'P2096',
      'P2097',
      'P2098',
    ],
    bandas: [
      11
    ]
  },{
    name: 'obligaciones_02',
    data: [
      'P2136',
      'P2137',
      'P2139',
    ],
    bandas: [
      11
    ]
  },{
    name: 'obligaciones_03',
    data: [
      'P2138',
      'P2140',
    ],
    bandas: [
      11
    ]
  },{
    name: 'patrimonio_01',
    data: [
      'P3001',
      'P3002',
      'P3003',
      'P3004',
      'P3005',
      'P3006',
      'P3007',
      'P3008',
      'P3009',
      'P3010',
      'P3011',
      'P3012',
      'P3013',
      'P3014',
      'P3015',
      'P3016',
      'P3017',
      'P3018',
      'P3019',
      'P3020',
      'P3021',
      'P3022',
      'P3023',
      'P3024',
      'P3025',
      'P3026',
      'P3027',
    ],
    bandas: [
      11
    ]
  },{
    name: 'contingencias_02',
    data: [
      'O6023',
      'O6024',
      'O6025',
      'O6026',
      'O6027',
      'O6028',
      'O6029',
      'O6030',
      'O6031',
      'O6032',
      'O6033',
      'O6034',
      'O6035',
      'O6036',
      'O6037',
      'O6038',
      'O6039',
      'O6040',
      'O6041',
      'O6042',
      'O6043',
      'O6044',
      'P2119',
      'P2120',
    ],
    bandas: [
      11
    ]
  },{
    name: 'provisiones_02',
    data: [
      'P2119',
      'P2120',
    ],
    bandas: [
      11
    ]
  },{
    name: 'pasivos_02',
    data: [
      'P2141',
      'P2142',
      'P2143',
      'P2144',
      'P2145',
      'P2146',
      'P2147',
      'P2148',
      'P2149',
      'P2150',
    ],
    bandas: [
      11
    ]
  }
]